import { useCallback, useEffect, useState } from 'react';
import useApiClient from './useApiClient';

export default function usePageLike(initial: boolean[], articleId: string) {
  const [pagesLiked, setPagesLiked] = useState(initial);
  const { apiClient } = useApiClient();

  useEffect(() => {
    // articleIdが変化した場合は保存済みフラグの値を初期化する
    setPagesLiked(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleId]);

  const setPagesLikedAt = useCallback(
    (index: number, liked: boolean) => {
      const newPagesLiked = [...pagesLiked];
      newPagesLiked[index] = liked;
      setPagesLiked(newPagesLiked);
    },
    [pagesLiked],
  );

  const likePage = useCallback(
    async (pageNum: number) => {
      const index = pageNum - 1;
      if (pagesLiked[index]) {
        return;
      }

      // 通信完了を待たずに表示上完了とする
      setPagesLikedAt(index, true);

      try {
        const res = await apiClient('/api/article/page/like', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            articleId,
            pageNum,
          }),
        });
        if (res.ok) {
          // 何もしない
        } else {
          throw new Error();
        }
      } catch {
        setPagesLikedAt(index, false);
        throw new Error();
      }
    },
    [pagesLiked, setPagesLikedAt, articleId, apiClient],
  );

  const unlikePage = useCallback(
    async (pageNum: number) => {
      const index = pageNum - 1;
      if (!pagesLiked[index]) {
        return;
      }

      // 通信完了を待たずに表示上完了とする
      setPagesLikedAt(index, false);

      try {
        const res = await apiClient('/api/article/page/unlike', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            articleId,
            pageNum,
          }),
        });
        if (res.ok) {
          // 何もしない
        } else {
          throw new Error();
        }
      } catch {
        setPagesLikedAt(index, true);
        throw new Error();
      }
    },
    [pagesLiked, setPagesLikedAt, articleId, apiClient],
  );

  return {
    pagesLiked,
    likePage,
    unlikePage,
  };
}
